import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import { formatMoney, STORE } from "../config/store";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity, maximum) => {
    if (newQuantity > 0 && maximum > 0) {
      updateQuantity(id, size, color, Math.min(newQuantity, maximum));
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page empty-cart">
        <h1>Your cart is empty</h1>
        <Link onClick={toTop} to="/shop" className="continue-shopping">
          Continue shopping
        </Link>
      </div>
    );
  }

  return (
    <div className="cart-page-container">
      <div className="cart-header">
        <h1>Your cart</h1>
        <Link onClick={toTop} to="/shop" className="continue-shopping">
          Continue shopping
        </Link>
      </div>

      <div className="cart-content">
        <div className="cart-items-section">
          <div className="cart-table-header">
            <span className="col-product">PRODUCT</span>
            <span className="col-quantity">QUANTITY</span>
            <span className="col-total">TOTAL</span>
          </div>

          {cartItems.map((item, index) => {
            const product = getProductById(item.id);
            if (!product) return null;

            const price = parseFloat(product.price.replace(/,/g, ""));
            const itemTotal = (price * item.quantity).toFixed(2);

            return (
              <div
                className="cart-item"
                key={`${item.id}-${item.size}-${item.color}-${index}`}
              >
                <div className="col-product">
                  <div className="product-image">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="product-details">
                    <Link
                      onClick={toTop}
                      to={`/shopDetails/${product.id}`}
                      className="product-name"
                    >
                      {product.name}
                    </Link>
                    <div className="product-price">{formatMoney(product.price)}</div>

                    {item.size && item.size !== "One size" && (
                      <div className="product-variant">Size: {item.size}</div>
                    )}
                    {item.color && (
                      <div className="product-variant">Color: {item.color}</div>
                    )}
                  </div>
                </div>

                <div className="col-quantity">
                  <div className="quantity-selector">
                    <button
                      onClick={() =>
                        handleUpdateQuantity(
                          item.id,
                          item.size,
                          item.color,
                          item.quantity - 1,
                          product.inventory
                        )
                      }
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      onClick={() =>
                        handleUpdateQuantity(
                          item.id,
                          item.size,
                          item.color,
                          item.quantity + 1,
                          product.inventory
                        )
                      }
                      disabled={item.quantity >= product.inventory}
                    >
                      +
                    </button>
                  </div>
                  <button
                    className="remove-btn"
                    onClick={() =>
                      removeFromCart(item.id, item.size, item.color)
                    }
                  >
                    Remove
                  </button>
                </div>

                <div className="col-total">{formatMoney(itemTotal)}</div>
              </div>
            );
          })}
        </div>

        <div className="cart-summary-section">
          <div className="summary-row">
            <span>Subtotal</span>
            <span className="subtotal-price">{formatMoney(subtotal)}</span>
          </div>
          <p className="shipping-note">
            A fixed {formatMoney(STORE.shippingFee)} shipping charge is added at checkout.
          </p>
          <button className="checkout-btn" onClick={handleCheckout}>
            Check out
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
